import React, { useState, useEffect, createRef, useRef } from 'react';
import styled, { keyframes } from 'styled-components'; 
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import constants from 'utils/constants'

import christmasPageTop from 'images/event/christmas_page_top-750x4976.png';
import christmasPageBottom from 'images/event/christmas_page_bottom-750x1846.png';
import TitleHeader from 'components/presenters/header/TitleHeader';
//Share
import { Helmet } from 'react-helmet-async'
import KakaoShareButton from 'components/containers/common/KakaoShareButton'
//Modal
import TaskResultFormModal from 'components/containers/task/modal/TaskResultFormModal'
import CenterModal from 'components/presenters/modal/CenterModal';

export default function ChristmasMainLayout({ match, targetNo, type }) {  
  const userInfo = useSelector((state) => {
    return state.userInfo;
  })
  //Upload
  const [currTask, setCurrTask] = useState(null); 
  const [initUploadState, setInitUploadState] = useState(false);
  //Edit TaskResult 
  const [initImgURL, setInitImgURL] = useState(null); 
  //TaskResultFormModal 
  const [showTaskResultForm, setShowTaskResultForm] = useState(false);
  const [resultModalFormId, setResultModalFormId] = useState(null);
  //CenterModal
  const [centerModalVisible, setCenterModalVisible] = useState(false);
  const [centerModalDataList, setCenterModalDataList] = useState(null);
  const [onCenterModalComplete, setOnCenterModalComplete] = useState(null);
  const [onCenterModalCancel, setOnCenterModalCancel] = useState(null);
  const [initCenterModal, setInitCenterModal] = useState(false);
  //Share
  const [shareImg, setShareImg] = useState(null);
  //CopyState
  const [copyAlarmVisible, setCopyAlarmVisible] = useState(false);

  const history = useHistory();
  const kakaoButton = createRef();
  const hashTag = useRef();
  const copyAlarm = useRef();
  
  const handleClickCancel = () => {
    setInitCenterModal(true);
  }

  const handleClickComplete = () => {
    history.push(`/social?redirect_path=${match.url}`);
    setInitCenterModal(true);
  }

  const checkProceeding = () => {
    const currDate = new Date();
    const christmasEveDate = new Date('2021-12-24');
    const christmasDate = new Date('2021-12-25');

    currDate.setHours(0, 0, 0, 0);
    christmasEveDate.setHours(0, 0, 0, 0);
    christmasDate.setHours(0, 0, 0, 0);

    if((currDate.valueOf() >= christmasEveDate.valueOf()) && (currDate.valueOf() <= christmasDate.valueOf()))
    {
      return true;
    }
    return false;
  }

  const handleClickCertification = () => {

    if(!userInfo.isLogin)
    {
      setCenterModalDataList({type: 'callback', description: '로그인이 필요해요'});
      setOnCenterModalComplete(() => () => handleClickComplete());
      setOnCenterModalCancel(() => () => handleClickCancel())
      setCenterModalVisible(true);
      return;
    }

    if(!checkProceeding())
    {
      setCenterModalDataList({type: 'callback', description: '이벤트가 종료되었어요!✨'});
      setOnCenterModalComplete(() => () => setCenterModalVisible(false));
      setCenterModalVisible(true);
      return;
    }
    
    setShowTaskResultForm(true);
  }

  const handleClickClose = () => {
    setInitUploadState(true);
  }

  const handleClickSubmit = () => {
    setInitUploadState(true);
    history.push('/feed');
  }

  const handleClickCopy = () => {
    if(userInfo.deviceType === 'iOS')
    {
      const prevContentEditable = hashTag.current.contentEditable;
      const prevReadOnly = hashTag.current.readOnly;
      const range = document.createRange();
    
      hashTag.current.contentEditable = true;
      hashTag.current.readOnly = false;
      range.selectNodeContents(hashTag.current);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      

      hashTag.current.setSelectionRange(0, 999999);
      
      hashTag.current.contentEditable = prevContentEditable;
      hashTag.current.readOnly = prevReadOnly;
    }
    else
    {
      hashTag.current.select();
      hashTag.current.setSelectionRange(0, 99999);      
    }
    
    document.execCommand('copy');
    hashTag.current.setSelectionRange(0, 0);
    hashTag.current.blur();
    setCopyAlarmVisible(true);
  }

  //Upload Result Flow
  useEffect(()=>{
    if(initUploadState === true)
    {
      setInitImgURL(null);
      setCurrTask(null);
      setShowTaskResultForm(false);
      setInitUploadState(false);
    } 

  },[initUploadState])

  useEffect(() => {
    if(initCenterModal === true)
    {
      setCenterModalVisible(false);
      setCenterModalDataList(null);
      setOnCenterModalCancel(null);
      setOnCenterModalComplete(null);
      setInitCenterModal(false);
    }
  }, [initCenterModal])

  useEffect(() => {
    if(copyAlarmVisible === true)
    {
      // copyAlarm.current.classList.add('slide_on');
      setTimeout(() => {
        copyAlarm.current.classList.add('slide_out');
        setTimeout(() => {
          setCopyAlarmVisible(false);
        }, 300)
      }, 2000)
    }
    return () => clearTimeout();
  }, [copyAlarmVisible])

  useEffect(() => {
    if(process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'qa')
    {
      setShareImg(`${constants.imagePath}/banner_cover_img/9_1638870468319_85f653ef-09b7-419c-a8f6-b856913ee0ec.png`);
    }
    else
    {
      setShareImg(`${constants.imagePath}/banner_cover_img/3_1640134779136_406ec35e-afbb-48f3-b201-777ddd7137d6.png`);
    }
  }, [])

  return (
    <MainInner  >
      <HeaderWrapper>
        <TitleHeader title={'크리스마스 이벤트'}/>
      </HeaderWrapper>
      <TaskResultFormModal 
        visible={showTaskResultForm}
        setVisible={setShowTaskResultForm}
        taskNo={(currTask)?currTask['no']:null} 
        defaultTaskTitle={'크리스마스 이벤트🎄'}
        onClose={()=>{
          handleClickClose();
        }}
        onSubmit={async ()=>{ 
          handleClickSubmit(); 
        }}
        onLoadModalId={(id)=>{setResultModalFormId(id)}}
      />
      <BannerWrapper>
        <BannerImg src={christmasPageTop} />
        <HashTagBlock>
          <HashTagInner>
            <HashTagTitle>{'인스타그램에\n해시태그와\n같이 캡쳐본 업로드'}</HashTagTitle>
            <HashTagTextBlock>
              <HashTag>{"#크확행챌린지 #메리몽드 #그을린 #퓨어플랜 #건강선생 #필로메디\n#포제이 #바른단백 #모티너스"}</HashTag>
              <HashTagText ref={hashTag} value={`#크확행챌린지 #메리몽드 #그을린 #퓨어플랜 #건강선생 #필로메디 #포제이 #바른단백 #모티너스`} rows={0} readOnly contentEditable/>
            </HashTagTextBlock>
            <CopyButton  onClick={handleClickCopy} className={'slide_on'}>{'해시태그 복사하기'}</CopyButton>
          </HashTagInner>
        </HashTagBlock>
        <BannerImg src={christmasPageBottom} />
        <ShareButtonBlock>
          <ShareButton onClick={() => {
            kakaoButton.current.click()}}>
            함께 하고 싶은 친구 소환👋
            <Helmet>
              <script src="https://developers.kakao.com/sdk/js/kakao.js"></script>
            </Helmet>
            <KakaoShareButton 
              queryString={{}} 
              kakaoButton={kakaoButton}
              shareTitle={'모티너스가 준비한 연말 이벤트'}
              shareDescription={`🎄홍대에서 열리는 크리스마스 챌린지🎄\n인증만 하면 크리스마스 선물 득템✨`}
              shareImg={shareImg}
            ></KakaoShareButton>
          </ShareButton>
        </ShareButtonBlock>
        {copyAlarmVisible ? (
          <CopyCompleteAlarmBlock ref={copyAlarm}>해시태그가 복사 되었어요!</CopyCompleteAlarmBlock>
        ) : null}
      </BannerWrapper>
      <CertificationButtonBlock onClick={handleClickCertification}>
        인증하러 가기
      </CertificationButtonBlock>
      <CenterModal modalVisible={centerModalVisible} dataList={centerModalDataList} onCancel={onCenterModalCancel} onComplete={onCenterModalComplete}/>
    </MainInner>
  );
}

export const MainInner = styled.div`
  overflow-y: scroll;
  height: 100%;
  overflow-x: hidden;
`;

const HeaderWrapper = styled.div`
  flex: 0 1 auto;
  height: calc(100vw*(51/375));
  min-height: calc(100vw*(51/375));
`;

export const MainBannerWrapper = styled.div`
  margin-bottom: calc(100vw * (32 / 375));
`;

export const BannerWrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
  width: 100%;
  margin-bottom: calc(100vw * (72 / 375));
`
export const BannerImg = styled.img`
  width : 100%;
  height: 100%;
  object-fit: contain;
`
const ShareButtonBlock = styled.div`
  width: 100%;
  padding: 0  calc(100vw * (25 /375)) calc(100vw * (34 /375)) calc(100vw * (25 /375));
`;

const ShareButton = styled.button`
  color: #fff;
  font-size: calc(100vw * (18 / 375));
  font-weight: bold;
  margin: auto;
  border-radius: calc(100vw * (91 / 375));
  background-color: #121212;
  width: 100%;
  height: calc(100vw * (75 / 375));
`;

const CertificationButtonBlock = styled.div`
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vw * (72 / 375));
  width: 100%;
  background-color: #FFCF19;
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
`;

const HashTagBlock = styled.div`
  padding: 0 calc(100vw * (31 / 375));
`;

const HashTagInner = styled.div`
  width: 100%;
  background-color: #F7F7F7;
  padding: calc(100vw * (26 / 375)) calc(100vw * (24 / 375)) calc(100vw * (18 / 375));
`;

const HashTagTitle = styled.h1`
  white-space: pre-wrap;
  text-align:center;
  font-size: calc(100vw * (16 / 375));
  font-weight: 700;
  line-height: calc(100vw * (23.17 / 375));
`;

const HashTagTextBlock = styled.div`
  position: relative;
  background: #fff;
  padding: calc(100vw * (19 / 375)) calc(100vw * (47 / 375));
  margin-top: calc(100vw * (25 / 375));
  box-shadow: 0px 0px calc(100vw * (20 / 375)) rgba(191, 191, 191, 0.5);
  border-radius: 5px;
`;

const HashTag = styled.div`
  width: 100%;
  font-size: calc(100vw * (12 / 375));
  font-weight: 700;
  line-height: calc(100vw * (17.38 / 375));
  color: #3d96ff;
  white-space: pre-wrap;
  text-align: center;
`;

const HashTagText = styled.input`
  position: absolute;
  width: 100%;
  font-size: calc(100vw * (12 / 375));
  font-weight: 700;
  line-height: calc(100vw * (17.38 / 375));
  color: #3d96ff;
  text-align: center;
  overflow: hidden;
  opacity: 0;
`;

const CopyButton = styled.div`
  width: 100%;
  background: #121212;
  color: #fff;
  font-size: calc(100vw * (12 / 375));
  font-weight: 700;
  margin-top: calc(100vw * (15 / 375));
  padding: calc(100vw * (15 / 375)) 0;
  text-align: center;
  border-radius: 5px;
`;

const slideOut = keyframes`
  0% { top: calc(100vw * (51 / 375)); }
  10% { top: calc(100vw * (41 / 375)); }
  20% { top: calc(100vw * (31 / 375)); } 
  30% { top: calc(100vw * (21 / 375)); }
  55% { top: calc(100vw * (11 / 375)); }
  65% { top: calc(100vw * (5 / 375)); }
  80% { top: calc(100vw * (3 / 375)); }
  100% { top: calc(100vw * (0 / 375)); }
`;

const CopyCompleteAlarmBlock = styled.div`
  position: fixed;
  top: calc(100vw * (51 / 375));
  width: 100%;
  padding: calc(100vw * (18 / 375)) 0;
  background-color: #ffcf19;
  text-align: center;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (20.27 / 375));
  &.slide_out {
    animation: ${slideOut} .3s;
  }
`;